<template>
  <div class="public-shop member-auth-page">
    <header class="shop-header member-auth-hero" :style="{ background: themeGradient }">
      <div class="container member-auth-hero-inner">
        <router-link :to="shopPath('')" class="member-auth-back">
          <i class="fas fa-arrow-left"></i> Kembali ke Toko
        </router-link>
        <div class="member-auth-brand" v-if="shop">
          <img v-if="shop.logo_url" :src="shop.logo_url" alt="" class="member-auth-logo">
          <div v-else class="member-auth-logo-placeholder">
            <i class="fas fa-store"></i>
          </div>
          <div>
            <h1 class="member-auth-shop-name text-white">{{ shop.name }}</h1>
            <small class="text-white-50">Portal Member</small>
          </div>
        </div>
      </div>
    </header>

    <div class="container member-auth-wrap">
      <div class="row justify-content-center">
        <div class="col-md-5 col-lg-4">
          <div class="member-auth-card shop-card p-4 p-md-5">
            <div class="member-auth-card-header mb-4">
              <div class="member-auth-icon-wrap">
                <i class="fas fa-user-circle"></i>
              </div>
              <h2 class="member-auth-title">Login Member</h2>
              <p class="member-auth-subtitle">Masuk untuk melihat pesanan, kursus, dan produk digital Anda</p>
            </div>

            <div v-if="error" class="member-alert member-alert-danger">
              <i class="fas fa-exclamation-circle"></i>
              <span>{{ error }}</span>
            </div>

            <form @submit.prevent="submit">
              <div class="member-form-group">
                <label class="member-form-label">Email</label>
                <input
                  v-model="email"
                  type="email"
                  class="member-form-input"
                  placeholder="email@example.com"
                  required
                  autocomplete="email"
                  :disabled="loading"
                >
              </div>
              <div class="member-form-group">
                <label class="member-form-label">Password</label>
                <div class="member-input-group">
                  <input
                    v-model="password"
                    :type="showPass ? 'text' : 'password'"
                    class="member-form-input"
                    placeholder="Masukkan password"
                    required
                    minlength="6"
                    autocomplete="current-password"
                    :disabled="loading"
                  >
                  <button type="button" class="member-input-toggle" @click="showPass = !showPass" tabindex="-1">
                    <i :class="showPass ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                  </button>
                </div>
              </div>
              <button type="submit" class="member-btn-primary" :disabled="loading">
                <span v-if="loading"><i class="fas fa-spinner fa-spin"></i> Memproses...</span>
                <span v-else><i class="fas fa-sign-in-alt mr-1"></i> Masuk</span>
              </button>
            </form>

            <div class="member-footer-link">
              <router-link :to="shopPath('/member/forgot-password')" class="member-link">
                Lupa password?
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import publicShopPaths from './public_shop_paths';
import { applyShopTheme, shopHeaderBackground, shopPublicMixin } from '@/components/shop_public/shop_public_utils';
import '@/components/shop_public/shop_public.css';
import '@/components/shop_public/member_portal.css';

export default {
  mixins: [publicShopPaths, shopPublicMixin],
  data() {
    return {
      shop: null,
      email: '',
      password: '',
      showPass: false,
      loading: false,
      error: '',
    };
  },
  computed: {
    themeGradient() {
      return shopHeaderBackground(this.shop);
    },
  },
  async mounted() {
    await this.loadShop();
    const saved = this.$store.getters['public_shop/memberSession'](this.effectiveSlug);
    if (saved?.token) {
      this.$router.replace(this.shopPath('/member/dashboard'));
    }
  },
  methods: {
    async loadShop() {
      if (this.onCustomDomain) {
        await this.$store.dispatch('public_shop/public_get_shop_by_domain');
      }
      const r = await this.$store.dispatch('public_shop/public_get_shop', this.effectiveSlug);
      this.shop = r.data.data.shop;
      applyShopTheme(this.shop);
    },
    async submit() {
      this.loading = true;
      this.error = '';
      try {
        const r = await this.$store.dispatch('public_shop/member_login', {
          slug: this.effectiveSlug,
          email: this.email,
          password: this.password,
        });
        const { token, member } = r.data.data;
        this.$store.commit('public_shop/SET_MEMBER_SESSION', {
          slug: this.effectiveSlug,
          token,
          member,
        });
        this.$router.push(this.shopPath('/member/dashboard'));
      } catch (e) {
        this.error = e.response?.data?.message || 'Login gagal. Periksa email dan password.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
